export default __webpack_public_path__ + "static/media/wallet ex black 2.8acd53b2.svg";